import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function executiveCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    return /^\d{6}$/.test(control.value)
      ? null
      : { invalidExecutiveCode: true };
  };
}
